<template>
  <div class="duoduo">
    <div class="duoduobg">
      <appHeader activeIndex="duoduo" ></appHeader>
      <div class="duoduoContent">
        <!-- 介绍 -->
        <div class="duoduoInfo">
          <div class="duoduoInfo1">
            <img class="duoduoInfo1Img1" src="../../assets/img/Product/duoduo.png"  alt />
            <br>
            <img class="duoduoInfo1Img2"  src="../../assets/img/products/duoduo/duoduoQRcode.png" alt />
            <div>扫描二维码下载</div>     
          </div>
          <div class="duoduoInfo2">
            <img src="../../assets/img/products/duoduo/duoduoFont.png" alt />
             <el-divider></el-divider>
             <h2>应用介绍</h2>
             <p>安卓多多壁纸：利用精美的壁纸和多功能来妆点您的手机。</p>
             <p>【壁纸实时更新】超多精美壁纸每天更新，带给你新鲜活力体验！想怎么换就怎么换！</p>
             <p>【海量壁纸资源】安卓多多壁纸搜集了超火的娱乐明星、网红小姐姐、自然景观、城市建筑等等，给你无限选择！</p>
             <p>【高清精美壁纸】每一张壁纸都是高清精美的，色彩或浓郁鲜艳，或清新甜美，或高端大气，用他们来为你的手机装扮添彩吧！</p>
             <p>【壁纸一键更换】选择你喜欢的一张壁纸，点击确认就可以更换啦！超级简单实用，人性化设计哦！</p>
             <p> 安卓多多壁纸，每天都为手机换新颜！ </p>
          </div>
          <div style="clear: both;"></div> 
        </div>
        <!-- 第二部分内容 -->
        <el-divider></el-divider>
        <div class="duoduoCarousel">
          <div class="iconLeft" @click="left"><el-button icon="el-icon-arrow-left" circle></el-button></div>
          <div class="iconRight" @click="right"><el-button icon="el-icon-arrow-right" circle></el-button></div>
          <div class="duoduoWrap">
            <div class="duoduoMainImg" :style="{ left: nowLeft + '%' }">
              <img class="duoduoCarouselImg"   src="../../assets/img/products/duoduo/carousel.png" alt />
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <appFooter></appFooter>

  </div>
</template>
 
<script>
import appHeader from "../components/Header";
import appFooter from "../components/Footer";
export default {
  components: {
    appHeader,appFooter
  },
  data() {
    return {
      nowLeft: 0
    };
  },
  mounted() {},
  methods: {
    
      left() {
        
        if(this.nowLeft >= 0){
          return;
        }
        this.nowLeft = this.nowLeft +15
      },

      right() {
        if(this.nowLeft <= -45){
          return;
        }
        this.nowLeft = this.nowLeft -15
      }
  }
};
</script>
<style>
@import "../../assets/css/products/duoduo.css";
</style>
